export default __webpack_public_path__ + "static/media/Testimony2.dbe8e2d6.svg";